module.exports = __webpack_public_path__ + "img/katarina_events_4.1d7647a7.jpg";